import { render, staticRenderFns } from "./homeconfig.vue?vue&type=template&id=572df63b&scoped=true"
import script from "./homeconfig.vue?vue&type=script&lang=js"
export * from "./homeconfig.vue?vue&type=script&lang=js"
import style0 from "./homeconfig.vue?vue&type=style&index=0&id=572df63b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572df63b",
  null
  
)

export default component.exports